'use client';
import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${props => props.theme.colors.background.base};
`;

export const Main = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
